import { useSelector } from 'react-redux';
import { FC, useState } from 'react';
import Box from '@mui/material/Box';
import { Wrapper } from './styled';
import Typography from '@mui/material/Typography';
import medic01 from '../../../images/medic01.png';
import medic02 from '../../../images/medic02.png';
import medic04 from '../../../images/medic04.png';
import medic05 from '../../../images/medic05.png';
import medic06 from '../../../images/medic06.png';
import Button from '@mui/material/Button';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';
import CardMedia from '@mui/material/CardMedia';

import { RootState } from '../../../store';
import { customEventTracking } from '../../../lib/gtm';

interface ListMedicInfo {
  name: string;
  infoDocs: JSX.Element;
  userId: string;
  subTitle: string;
  image: string;
  text?: JSX.Element;
}

const listMedicInfo: ListMedicInfo[] = [
  {
    name: 'Dra. Natalia Ramos',
    userId: process.env.REACT_APP_ID_DOCTOR_NATALIA_RAMOS || '',
    infoDocs: (
      <>
        <b>CRM</b> 169753 | <b>RQE</b> 85112
      </>
    ),
    subTitle: 'Ginecologista especialista em Fertilidade',
    image: medic01
  },
  {
    name: 'Dra. Ana Flávia Hostalácio',
    userId: process.env.REACT_APP_ID_DOCTOR_ANA_FLAVIA || '',
    infoDocs: (
      <>
        <b>CRM</b> 180810 | <b>RQE</b> 86160
      </>
    ),
    subTitle: 'Ginecologista especialista em Fertilidade',
    image: medic02
  },
  {
    name: 'Dra. Mariana Schmidt',
    userId: process.env.REACT_APP_ID_DOCTOR_MARIANA_SCHMIDT || '',
    infoDocs: (
      <>
        <b>CRM</b> 241931 | <b>RQE</b> 1115821
      </>
    ),
    subTitle: 'Ginecologista especialista em Fertilidade',
    image: medic04
  },
  {
    name: 'Dra. Thaís Luzo',
    userId: process.env.REACT_APP_ID_DOCTOR_THAIS_LUZO || '',
    infoDocs: (
      <>
        <b>CRM</b> 201330 | <b>RQE</b> 100817
      </>
    ),
    subTitle: 'Ginecologista especialista em Fertilidade',
    image: medic05
  },
  {
    name: 'Dra. Gabriela Prata',
    userId: process.env.REACT_APP_ID_DOCTOR_GABRIELA_PRATA || '',
    infoDocs: (
      <>
        <b>CRM</b> 192635 | <b>RQE</b> 100999
      </>
    ),
    subTitle: 'Ginecologista especialista em Fertilidade',
    image: medic06
  }
];

export const CardDoctor: FC = () => {
  const { product } = useSelector((state: RootState) => state);
  const [openViewMore, setOpenViewMore] = useState<number | null>(null);
  const navegate = useNavigate();
  const handleClick = (id: number) => {
    setOpenViewMore(openViewMore => (openViewMore === id ? null : id));
  };

  return (
    <>
      {listMedicInfo.map((resp, key) => {
        return (
          <Wrapper mb={3} key={resp.name}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex' }}>
                <Box>
                  <CardMedia src={resp.image} component="img" sx={{ width: '64px', borderRadius: '10px' }} />
                </Box>
                <Box ml={3}>
                  <Typography variant="h4" mb={1}>
                    {resp.name}
                  </Typography>
                  <Typography variant="body6" mb={0.5}>
                    {resp.infoDocs}
                  </Typography>
                  <Typography variant="body2R">{resp.subTitle}</Typography>
                </Box>
              </Box>
              <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <Button
                  variant="contained"
                  sx={{ padding: '12px 16px 14px 24px' }}
                  onClick={() => {
                    customEventTracking.send({ event: resp.name });
                    navegate(`/servico/${product.id}/especialista/${resp.userId}`);
                  }}
                >
                  <Typography variant="body1B" sx={{ mr: 1.5 }}>
                    Selecionar
                  </Typography>
                  <ArrowForwardIcon />
                </Button>
              </Box>
            </Box>
            <Box sx={{ display: { xs: 'block', md: 'none' }, mt: 3 }}>
              <Button
                variant="contained"
                sx={{ padding: '12px 16px 14px 24px', justifyContent: 'space-between' }}
                fullWidth
                onClick={() => {
                  customEventTracking.send({ event: resp.name });
                  navegate(`/servico/${product.id}/especialista/${resp.userId}`);
                }}
              >
                <Typography variant="body1B" sx={{ mr: 1.5 }}>
                  Selecionar
                </Typography>
                <ArrowForwardIcon />
              </Button>
            </Box>
          </Wrapper>
        );
      })}
    </>
  );
};

export default CardDoctor;
